import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar1 from "./Navbar1";
import Navbar2 from "./Navbar";
import Footer from "./Footer";

const Layout = () => {
  const location = useLocation();

  // Check if we're on a dashboard route
  const isDashboardRoute = location.pathname.startsWith("/dashboard");
  const isHome = location.pathname.startsWith("/home");

  return (
    <>
      {isHome && <Navbar1 />}
      {!isHome && <Navbar2 />}
      <main>
        <Outlet />
      </main>
      {/* Render footer only if not on a dashboard page */}
      {!isDashboardRoute && <Footer />}
    </>
  );
};

export default Layout;
